var PpcServiceCategoryData = React.createContext({});
export var PpcServiceCategoryDataProvider = PpcServiceCategoryData.Provider;
export var PpcServiceCategoryDataConsumer = PpcServiceCategoryData.Consumer;
export default PpcServiceCategoryData;